import React, { FunctionComponent, useEffect } from 'react'
import styles from './BindDropdown.module.sass'
import { switchMap } from 'rxjs/operators'
import { apiRequests } from '../../../../../../http/config'
import { RelatedProject, relatedToString } from '../../../../../../responses/projects'
import Button from '../../../../../controls/Button/Button'
import Label, { Display } from '../../../../../controls/Label/Label'
import { isNonEmpty } from 'fp-ts/es6/Array'
import BindIcon from 'files/bind.svg'
import CloseIcon from 'files/close.svg'
import { entityElem, getId } from '../../../../../../utils/entity-utils'
import { Bool, ID } from '../../../../../../types/UtilityTypes'
import { motion } from 'framer-motion'
import { fromQueryWithReset, listResponse } from '../../../../../../utils/rx-operators'
import Dropdown from '../../../../../data-components/dropdowns/Dropdown/Dropdown'
import { useObservableState } from 'observable-hooks'
import { unit } from '../../../../../../utils/utils'

interface Props {
    projectId: ID,
    value?: RelatedProject,
    related: RelatedProject[],
    onChange: (value: RelatedProject) => void,
    onDelete: () => void,
}

const BindDropdown: FunctionComponent<Props> = props => {
    const [data, onDataSearch] = useObservableState<RelatedProject[], {search: string, reset: boolean}>(fromQueryWithReset(query => apiRequests.project.relationList({
        query, params: { projectId: props.projectId },
    })), [])

    const [related, findRelated] = useObservableState<RelatedProject[], {is_design: Bool, projectId: ID}>(input$ => input$.pipe(
        switchMap(({is_design, projectId}) => apiRequests.project.relations({
            params: { projectId },
            query: { is_design }
        }).pipe(
            listResponse(`Ошибка получения связанных проектов для проекта ${projectId}`)
        )),
    ), [])

    useEffect(() => {
        if (props.value && !entityElem(props.value, props.related)) {
            findRelated({
                projectId: props.value.id,
                is_design: props.value.is_design,
            })
        }
    }, [props.value, props.related, findRelated])

    return <motion.div
        layout
        initial={{ height: 0 }}
        animate={{ height: 'auto' }}
        exit={{ height: 0 }}
        style={{ overflow: 'hidden' }}
    >
        <div className={styles.group}>
            <BindIcon className={styles.icon}/>
            <Label display={Display.TOP} label={'Наименование проекта'}>
                <Dropdown
                    placeholder={'Не выбран'}
                    content={(selected, render) => selected.map(render).join()}
                    selected={unit(props.value)}
                    data={data}
                    projectIcon={true}
                    render={item => relatedToString(item, true)}
                    toKey={getId}
                    onClick={item => !entityElem(item, props.related) && props.onChange(item)}
                    onChange={(search, reset) => onDataSearch({search, reset})}
                    projectIconSelected={props.value?.is_design}
                />
                <Button
                    className={styles.button}
                    onClick={() => {
                        close()
                        props.onDelete()
                    }}
                >
                    <CloseIcon/>
                </Button>
                {
                    isNonEmpty(related) && <Label
                        className={styles.relatedLabel}
                        label={'Связанные проекты'}
                        display={Display.TOP}
                    >
                        <div className={styles.relatedProjects}>
                            {related.map(item => <div key={item.id}>
                                {relatedToString(item, true)}
                            </div>)}
                        </div>
                    </Label>
                }
            </Label>
        </div>
    </motion.div>
}

export default BindDropdown